import React from "react";

class Orders extends React.Component {
  render() {
    const { Bs, SIZE, VARIANT, _icon } = this.props;
    return (
      <Bs row className="mt-2">
        <Bs col xs={12}>
          <Bs card bg={VARIANT.UNI} className="mb-4">
            <Bs cardbody>
              <Bs row>
                <Bs col xs={12}>
                  <Bs row className="d-flex justify-content-start">
                    <Bs col xs={12} lg={9}>
                      <Bs
                        button
                        size={SIZE.MD}
                        variant={VARIANT.LIGHT}
                        className="me-2 fs-25"
                        data-tip="Přidat díl do košíku"
                      >
                        <_icon faplus />
                      </Bs>
                      <Bs
                        button
                        size={SIZE.MD}
                        variant={VARIANT.LIGHT}
                        className="me-2 fs-25"
                        data-tip="Historie objednávek"
                      >
                        <_icon fastream />
                      </Bs>
                      <Bs
                        button
                        size={SIZE.MD}
                        variant={VARIANT.LIGHT}
                        className="me-2 fs-25"
                        data-tip="OFS Forecast"
                      >
                        <_icon fadownload />
                      </Bs>
                    </Bs>
                    <Bs
                      col
                      xs={12}
                      lg={3}
                      className="d-flex justify-content-end"
                    >
                      <Bs
                        button
                        size={SIZE.MD}
                        variant={VARIANT.LIGHT}
                        className="me-2 fs-25"
                        data-tip="Zobrazit nákupní košík"
                      >
                        <_icon facartshopping />
                      </Bs>
                    </Bs>
                  </Bs>
                </Bs>
              </Bs>
            </Bs>
          </Bs>
        </Bs>
      </Bs>
    );
  }
}

export default Orders;
